import { FormGroup } from "@blueprintjs/core";
import { ComplexProps } from "../../types/fieldTypes";
import { FormFieldErrorContainer } from "../FieldError/FormFieldErrorContainer";
import { CoreFieldProps } from "../../types/fieldTypes";
import { isFunction } from "lodash";
import { FC, useMemo } from "react";

export interface ComplexFieldProps<TFieldProps> extends ComplexProps {
  type: "Complex";
  renderer: ComplexRendererBuilder<TFieldProps>;
  renderDependency?: unknown;
  formValue?: unknown;
}

export type ComplexRendererBuilder<TFieldProps> = (
  rendererProps: TFieldProps
) => React.ReactNode;

const ComplexFieldComponent = <TFieldProps extends CoreFieldProps>(
  props: ComplexFieldProps<TFieldProps> & TFieldProps
) => {
  if (!props.renderer || !isFunction(props.renderer)) {
    throw new Error(
      `Component with Field Key ${props.fieldKey} is defined as Complex, but a valid renderer function is not provided.`
    );
  }

  // Please note that, if we render the complex field renderer as a function
  // React will consider your custom component to be a part of the "<ComplexFieldComponent />"
  // This causes problem if you are using hooks inside of the custom components
  const RendererComponent = useMemo<
    FC<ComplexFieldProps<TFieldProps> & TFieldProps>
  >(() => (props) => props.renderer(props), [props.renderDependency]);

  return (
    <FormGroup className="base-field">
      <RendererComponent {...props} />
      {props.errorMessages && (
        <FormFieldErrorContainer errorMessages={props.errorMessages} />
      )}
    </FormGroup>
  );
};

export const ComplexField = ComplexFieldComponent;
export default ComplexField;
